var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.canExpand)?_c('div',{staticClass:"expand"},[_c('el-link',{attrs:{"underline":false,"type":"primary","icon":"el-icon-full-screen"},on:{"click":_vm.handleExpand}},[_vm._v(" Rozciągnij ")])],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }